module.exports = __webpack_public_path__ + "img/d6e9ef3.png";